import { FullscreenUtil } from "../FullscreenUtil.js";
import { VideoPlayerButton } from "./VideoPlayerButton.js";

export class VideoPlayerFullscreenButton extends VideoPlayerButton<"fullscreen" | "normal"> {

    private _fullscreen: boolean = false;

    public icons = {
        "fullscreen": "icon-250",
        "normal": "icon-249"
    };

    public create(): void {
        this.position = "right";
        this.iconState = "normal";

        FullscreenUtil.onChange.add((fullscreen, element) => {
            if (fullscreen) {
                this.fullscreen = element === this._player.element;
            } else {
                this.fullscreen = false;
            }
        });
    }

    public get supported(): boolean {
        return FullscreenUtil.isSupported;
    }

    protected click(): void {
        if (this.fullscreen) {
            FullscreenUtil.exit();
        } else {
            FullscreenUtil.enter(this._player.element);
        }
    }

    private get fullscreen(): boolean {
        return this._fullscreen;
    }

    private set fullscreen(fullscreen: boolean) {
        if (this._fullscreen === fullscreen)
            return;
        this._fullscreen = fullscreen;
        this.iconState = fullscreen ? "fullscreen" : "normal";
    }
}